import Guard from 'arg-guard'

import Logger from '@/logger'
import Service from './service'
import ServiceOperation from './service-operation'

import LinkedSchemeData from '@/models/linked-scheme-data'
import SchemeDataSummary from '@/models/scheme-data-summary'

/**
 * Gateway for accessing the scheme service.
 *
 * @export SchemeService
 * @class SchemeService
 */
export default class SchemeService extends Service {

    /**
     * Creates an instance of SchemeService.
     * @param {?number} schemeId The scheme for the active context.
     * @memberof ProfileService
     */
    constructor({ schemeId } = { schemeId: null }) {
        super('/scheme', 'Scheme')

        Guard.throwIf(schemeId, 'schemeId')
        this.schemeId = schemeId
    }

    /**
     * Loads all serviced schemes.
     * @returns {Promise<ServiceOperation>} The operation result.
     * @memberof SchemeService
     */
    async loadServicedSchemesAsync() {
        const operationState = new ServiceOperation('Load Serviced Schemes', true)
        const url = `serviced/for-scheme/${ this.schemeId }`
        Logger.log(`${ this.baseUrl }/${ url }`, 'Request [GET]')

        return await this._processGet(url, operationState, 'loadServicedSchemesAsync',
            (sourceData) => sourceData.map(partner => new SchemeDataSummary(partner)))
    }

    /**
     * Loads all serviced schemes linked to the provided address.
     * @param {number} addressId The address identifier.
     * @returns {Promise<ServiceOperation>} The operation result.
     * @throws addressId is not provided.
     * @memberof SchemeService
     */
    async loadServicedSchemesForAddressAsync(addressId) {
        Guard.throwIf(addressId, 'addressId')

        const operationState = new ServiceOperation('Load Serviced Schemes for Address', true)
        const url = `serviced/linked-to/${ addressId }/for-scheme/${ this.schemeId }`
        Logger.log(`${ this.baseUrl }/${ url }`, 'Request [GET]')

        return await this._processGet(url, operationState, 'loadServicedSchemesForAddressAsync',
            (sourceData) => new LinkedSchemeData(sourceData))
    }
}
